import '.an{position:relative;}.ssr-plugin'
import '.l{width:100%;}.ssr-plugin'
import '.hl{min-height:200px;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.ab{justify-content:center;}.ssr-plugin'
import '.av{align-items:flex-start;}.ssr-plugin'
import '.ec{padding:2rem;}.ssr-plugin'
import '.dr{background:var(--palette-white);}.ssr-plugin'
import '.bz{overflow:hidden;}.ssr-plugin'
import '.bg{position:absolute;}.ssr-plugin'
import '.jq{top:50%;}.ssr-plugin'
import '.jr{right:1rem;}.ssr-plugin'
import '.js{transform:translateY(-50%);}.ssr-plugin'
import '.jt{width:120px;}.ssr-plugin'
import '.ju{height:120px;}.ssr-plugin'
import '.jv{z-index:0;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.jc{z-index:1;}.ssr-plugin'
import '.s{gap:0.5rem;}.ssr-plugin'
import '.jw{max-width:calc(100% - 140px);}.ssr-plugin'
import '.jx{font-size:4rem;}.ssr-plugin'
import '.d3{font-weight:700;}.ssr-plugin'
import '.jy{line-height:100%;}.ssr-plugin'
import '.ha{margin:0px;}.ssr-plugin'
import '.a3{color:var(--brand-secondary);}.ssr-plugin'
import '.a4{font-family:FunnelDisplay;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="an l hl d e ab av ec dr bz"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="bg jq jr js jt ju jv d r ab"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="an jc d e av s jw"
      >
        <div className="jx d3 jy ha a3 a4"
        >
          {number}
        </div>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--brand-secondary)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
